
import PsLabel from "../label/PsLabel.vue";

export default {    
    name: "PsCheckboxValue",
    components: { PsLabel },
    props: {
        "value" : Boolean,
        "title" : {
            type : String,
            default : "N.A"
        }
    },
    setup(_, { emit }) {
        
        function handleInput(v) {                
            emit('update:value', v);
        }

        return {
            handleInput
        }
    }
}
